import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import classes from './deleteConfirmationModalShiftTimings.module.scss';

interface DeleteConfirmationModalProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModalShiftTiming = ({
  visible,
  onHide,
  onConfirm
}: DeleteConfirmationModalProps) => {
  return (
    <Dialog
      header="Delete This Row?"
      visible={visible}
      onHide={onHide}
      className={classes.modal}
      style={{ width: '450px' }}
    >
      <p>Are you sure you want to delete this row?</p>

      <div className={classes.modalFooter}>
        <Button label="Close" className="p-button-text" onClick={onHide} />
        <Button label="Yes, I'm Sure" className={classes.confirmButton} onClick={onConfirm} />
      </div>
    </Dialog>
  );
};

export default DeleteConfirmationModalShiftTiming;
